module.exports = "/packs/images/svg/ireland/facilities/extreme~8ea6017bba439262ee0edb60094c2aa1.svg";